$(document.body).prepend('<div class="svg-icon-map" style="display: none;"></div>');

$.get("https://www.mogo.ca/mogo-ui-lib-min/icons/mogo-ui-lib-svg-sprite.svg", function(data) {
  $('.svg-icon-map').append(new XMLSerializer().serializeToString(data.documentElement));
});
